// ============================================================================
// TARİH KRONOLOJİ VERİSİ — KPSS MÜFREDATI (21 ÜNİTE)
// Müfredat içindekiler tablosundan birebir alınmıştır.
// ============================================================================

export interface ChronologyUnit {
    id: string;
    label: string;          // Tam başlık
    shortLabel: string;     // Çubukta kısa gösterim
    dateRange: string;      // Tarih aralığı
    subTopics: string[];    // Alt başlıklar
}

// Eski interface'ler — geriye uyumluluk
export type ChronologyEra = ChronologyUnit;
export interface ChronologyState {
    id: string;
    name: string;
    founder?: string;
    capital?: string;
    years: string;
    keyFacts: string[];
    mapRegion?: string;
}

export const HISTORY_CHRONOLOGY: ChronologyUnit[] = [
    // ═══════════════════════════════════════════════════════════════
    // 1
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u1',
        label: 'İlk ve Orta Çağlarda Türk Dünyası',
        shortLabel: 'İlk Türkler',
        dateRange: 'MÖ 220 – MS 840',
        subTopics: [
            'Türk Göçleri, Orta Asya Kültür Çevreleri, İskitler',
            'Asya Hun Devleti (Büyük Hun Devleti)',
            'Avrupa Hun Devleti',
            'Hazar Devleti',
            'Avrupa\'da Kurulan Diğer Türk Devletleri ve Toplulukları',
            'I. Kök Türk Devleti ve Kutluk Devleti',
            'Uygurlar Devleti',
            'Orta Asya\'da Kurulan Diğer Türk Devletleri ve Toplulukları',
            'İlk Türk Devletlerinde Devlet Yönetimi',
            'İlk Türk Devletlerinde İkili Teşkilat, Kurultay ve Hükümet',
            'İlk Türk Devletlerinde Sosyal Hayat ve Hukuk',
            'İlk Türk Devletlerinde Ordu, Din ve İnanış',
            'İlk Türk Devletlerinde Ekonomi',
            'İlk Türk Devletlerinde Bilim, Sanat ve Spor',
            'İlk Türk Devletlerinde Yazı, Dil ve Edebiyat',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 2
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u2',
        label: 'Türklerin İslamiyet\'i Kabulü ve İlk Türk-İslam Devletleri',
        shortLabel: 'İlk İslam',
        dateRange: '751 – 1212',
        subTopics: [
            'Talas Savaşı (751) ve Türklerin İslamiyet\'i Kabulü',
            'Karahanlılar Devleti (840-1212)',
            'Gazneliler (963-1187)',
            'Büyük Selçuklu Devleti (1040-1157)',
            'Mısır\'da Kurulan İlk Türk-İslam Devletleri',
            'Anadolu\'da Kurulan İlk Türk-İslam Devletleri',
            'Orta Asya\'da ve Yakın Doğu\'da Kurulan Diğer Türk Devletleri',
            'İlk Türk-İslam Devletlerinde Devlet Yönetimi ve Saray',
            'İlk Türk-İslam Devletlerinde Hükümet, Taşra Yönetimi ve Hukuk',
            'İlk Türk-İslam Devletlerinde Ordu, Sosyal Hayat ve Toprak Yönetimi',
            'İlk Türk-İslam Devletlerinde Eğitim, Mimari ve Sanat',
            'Türk-İslam Bilim İnsanları',
            'İlk Türk-İslam Yazılı Eserleri',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 3
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u3',
        label: 'Yerleşme ve Devletleşme Sürecinde Selçuklu Türkiyesi',
        shortLabel: 'Selçuklu',
        dateRange: '1075 – 1308',
        subTopics: [
            'Türkiye (Anadolu) Selçuklu Devleti (1075-1308)',
            'Kösedağ Savaşı\'ndan Sonra Anadolu\'da Kurulan İkinci Türk Beylikleri',
            'Türkiye Selçuklu Devleti Kültür ve Medeniyeti',
            'Türkiye Selçuklu Devleti\'nde Mimari ve Sanat',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 4
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u4',
        label: 'Osmanlı Devleti Kültür ve Medeniyeti',
        shortLabel: 'Osmanlı Kültür',
        dateRange: '1299 – 1922',
        subTopics: [
            'Merkez Teşkilatı',
            'Osmanlı Devleti Merkez Teşkilatı – Saray',
            'Merkez Teşkilatı-Divanhümayun ve Üyeleri',
            'Osmanlı Devleti\'nde Taşra Teşkilatı',
            'Osmanlı Devleti\'nde Hukuk',
            'Osmanlı Devleti\'nde Sosyal Hayat',
            'Osmanlı Devleti\'nde Ordu',
            'Osmanlı Devleti\'nde Toprak Yönetimi',
            'Osmanlı Devleti\'nde Eğitim',
            'Osmanlı Devleti\'nde Bilim İnsanları',
            'Osmanlı Devleti\'nde Ekonomi',
            'Osmanlı Devleti\'nde Mimari',
            'Osmanlı Devleti\'nde Sanat, Spor, Yazı, Dil ve Edebiyat',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 5
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u5',
        label: 'Beylikten Devlete Osmanlı Devleti',
        shortLabel: 'Kuruluş',
        dateRange: '1299 – 1453',
        subTopics: [
            'Osmanlı Devleti Kurulduğu Sırada Yakın Doğu ve Avrupa (XIV. Yüzyıl)',
            'Osman Bey Dönemi (1299-1326)',
            'Orhan Bey Dönemi (1326-1362)',
            'I. Murat Dönemi (1362-1389)',
            'Yıldırım Bayezit (1398-1402) ve Fetret Devri (1402-1413)',
            'Çelebi Mehmet (1413-1421)-II. Murat (1421-1451)',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 6
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u6',
        label: 'Dünya Gücü Osmanlı',
        shortLabel: 'Yükselme',
        dateRange: '1453 – 1579',
        subTopics: [
            'Fatih Sultan Mehmet Dönemi (1451-1481)',
            'II. Bayezit Dönemi (1481-1512)',
            'Yavuz Sultan Selim Dönemi (1512-1520)',
            'Kanuni Sultan Süleyman Dönemi (1520-1566)',
            'Sokullu Mehmet Paşa Dönemi (1564-1579)',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 7
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u7',
        label: 'Değişen Dünya Dengeleri Karşısında Osmanlı Devleti (XVII. Yüzyıl)',
        shortLabel: 'XVII. YY',
        dateRange: '1579 – 1699',
        subTopics: [
            'Duraklamanın Nedenleri ve XVII. Yüzyıl Siyasi Olayları',
            'XVII. Yüzyıl İç İsyanları',
            'XVII. Yüzyıl Islahatçıları ve Yapılan Islahatlar',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 8
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u8',
        label: 'Değişen Dünya Dengeleri Karşısında Osmanlı Siyaseti (XVIII. Yüzyıl)',
        shortLabel: 'XVIII. YY',
        dateRange: '1699 – 1792',
        subTopics: [
            'Gerileme Dönemi (XVIII. Yüzyıl) Siyasi Olayları',
            'Gerileme Dönemi (XVIII. Yüzyıl) Islahatları',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 9
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u9',
        label: 'En Uzun Yüzyıl (XIX. Yüzyılda Osmanlı Devleti)',
        shortLabel: 'XIX. YY',
        dateRange: '1792 – 1876',
        subTopics: [
            'II. Mahmut Dönemi (1808-1839) Siyasi Olaylar',
            'Sultan Abdülmecit Dönemi (1839-1861) Siyasi Olaylar',
            'Sultan Abdülaziz (1861-1876) ve II. Abdülhamit (1876-1909) Dönemleri',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 10
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u10',
        label: 'XIX. Yüzyıl Osmanlı Devleti Islahatları',
        shortLabel: 'Islahatlar',
        dateRange: '1808 – 1909',
        subTopics: [
            'II. Mahmut Dönemi Islahatları',
            'Sultan Abdülmecit Dönemi Islahatları',
            'Sultan Abdülaziz Dönemi Islahatları',
            'II. Abdülhamit Dönemi Islahatları',
            'Osmanlı Devleti\'nde Darbe ve Darbe Girişimleri',
            'Osmanlı Devleti\'ni Dağılmaktan Kurtarma Fikirleri',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 11
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u11',
        label: 'XX. Yüzyıl Başlarında Osmanlı Devleti ve Dünya',
        shortLabel: 'XX. YY',
        dateRange: '1911 – 1918',
        subTopics: [
            'Trablusgarp Savaşı (1911-1912)',
            'I. Balkan Savaşı (1912-1913)',
            'II. Balkan Savaşı (1913)',
            'I. Dünya Savaşı (1914-1918)',
            'Osmanlı Devleti\'nin I. Dünya Savaşı\'nda Yer Aldığı Cepheler',
            'Kafkasya Cephesi',
            'Kanal (Süveyş)-Suriye ve Filistin Cephesi',
            'Çanakkale Cephesi',
            'Irak Cephesi',
            'Hicaz-Yemen Cephesi',
            'I. Dünya Savaşı Sırasında İmzalanan Gizli Antlaşmalar',
            'Wilson İlkeleri ve Ateşkes Antlaşmaları',
            'Mondros Ateşkes Antlaşması (30 Ekim 1918)',
            'Savaşın Sonuçları ve Paris Barış Konferansı',
            'İzmir\'in İşgali ve Kuvayi Milliye',
            'Yararlı Cemiyetler',
            'Zararlı Cemiyetler',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 12
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u12',
        label: 'Millî Mücadele Hazırlık Dönemi',
        shortLabel: 'Hazırlık',
        dateRange: '1919 – 1920',
        subTopics: [
            'Mustafa Kemal\'in İstanbul\'a Gelişi ve Samsun\'a Çıkışı',
            'Havza ve Amasya Genelgesi',
            'Erzurum Kongresi (23 Temmuz-7 Ağustos 1919)',
            'Yerel Kongreler',
            'Sivas Kongresi (4-11 Eylül 1919)',
            'Millî Mücadele Dönemi\'nde Basın ve Yayın Hareketleri',
            'Amasya Görüşmeleri (20-22 Ekim 1919)',
            'Son Osmanlı Mebusan Meclisinin Açılması ve Misakımillî Kararları',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 13
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u13',
        label: 'I. TBMM\'nin Açılması, İç Ayaklanmalar ve Sevr Barış Antlaşması',
        shortLabel: 'TBMM & Sevr',
        dateRange: '1920',
        subTopics: [
            'Birinci Türkiye Büyük Millet Meclisinin Açılması',
            'Birinci Türkiye Büyük Millet Meclisi',
            'TBMM\'ye Karşı Çıkan Ayaklanmalar',
            'Sevr Barış Antlaşması (10 Ağustos 1920)',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 14
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u14',
        label: 'Millî Mücadele Muharebeler Dönemi',
        shortLabel: 'Muharebeler',
        dateRange: '1920 – 1923',
        subTopics: [
            'Muharebeler Dönemi Cephelere Genel Bakış',
            'Doğu Cephesi',
            'Güney Cephesi',
            'Millî Mücadele Dönemi-Kadın Kahramanlarımız',
            'Batı Cephesi-I. İnönü Muharebesi',
            'I. İnönü Muharebesi\'nin Sonuçları',
            'II. İnönü Muharebesi (23 Mart-1 Nisan 1921)',
            'Kütahya-Eskişehir Muharebeleri (10-24 Temmuz 1921)',
            'Sakarya Meydan Muharebesi (23 Ağustos-13 Eylül 1921)',
            'Büyük Taarruz (Başkomutanlık Meydan Muharebesi) (26 Ağustos-9 Eylül 1922)',
            'Mudanya Ateşkes Antlaşması ve Saltanatın Kaldırılması',
            'Lozan Barış Antlaşması (24 Temmuz 1923)',
            'Lozan Barış Antlaşması\'nın Esasları',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 15
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u15',
        label: 'Mustafa Kemal Atatürk\'ün Hayatı',
        shortLabel: 'Atatürk',
        dateRange: '1881 – 1938',
        subTopics: [
            'Mustafa Kemal ATATÜRK (1881-∞)',
            'Mustafa Kemal\'i Etkileyen Yazarlar, Düşünürler, Şehirler ve Atatürk Kronolojisi',
            'Mustafa Kemal\'in Yazdığı Eserler, Kişiliği ve Özellikleri, Atatürk Hakkında Kısa Kısa',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 16
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u16',
        label: 'Atatürk Dönemi İç Politika Gelişmeleri',
        shortLabel: 'İç Politika',
        dateRange: '1923 – 1938',
        subTopics: [
            'Atatürk Dönemi İç Politika Gelişmeleri-I',
            'Atatürk Dönemi İç Politika Gelişmeleri-II',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 17
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u17',
        label: 'Atatürk İlkeleri',
        shortLabel: 'İlkeler',
        dateRange: '1923 – 1938',
        subTopics: [
            'Cumhuriyetçilik',
            'Laiklik',
            'Halkçılık',
            'Milliyetçilik',
            'Devletçilik',
            'İnkılapçılık',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 18
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u18',
        label: 'Atatürk İnkılapları',
        shortLabel: 'İnkılaplar',
        dateRange: '1922 – 1938',
        subTopics: [
            'Siyasi Alanda Yapılan İnkılaplar-I',
            'Siyasi Alanda Yapılan İnkılaplar-II',
            'Hukuk Alanında Yapılan İnkılaplar',
            'Toplumsal Alanda Yapılan İnkılaplar-I',
            'Toplumsal Alanda Yapılan İnkılaplar-II',
            'Eğitim ve Kültür Alanında Yapılan İnkılaplar-I',
            'Eğitim ve Kültür Alanında Yapılan İnkılaplar-II',
            'Eğitim ve Kültür Alanında Yapılan İnkılaplar-III',
            'Ekonomi Alanında Yapılan İnkılaplar-I',
            'Ekonomi Alanında Yapılan İnkılaplar-II',
            'Ekonomi Alanında Yapılan İnkılaplar-III',
            'Ulaşım, Bayındırlık, Sağlık ve Sosyal Alanda Yapılan İnkılaplar',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 19
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u19',
        label: 'Cumhuriyet Dönemi Kültür ve Medeniyeti',
        shortLabel: 'Cumh. Kültür',
        dateRange: '1923 – Günümüz',
        subTopics: [
            'Cumhuriyet Dönemi Kültür ve Medeniyeti-I',
            'Cumhuriyet Dönemi Kültür ve Medeniyeti-II',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 20
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u20',
        label: 'Atatürk Dönemi Dış Politikası',
        shortLabel: 'Dış Politika',
        dateRange: '1923 – 1939',
        subTopics: [
            'Atatürk Dönemi Dış Politikası (1923-1932 Arası)',
            'Atatürk Dönemi Dış Politikası (1932-1939 Arası)',
        ],
    },
    // ═══════════════════════════════════════════════════════════════
    // 21
    // ═══════════════════════════════════════════════════════════════
    {
        id: 'u21',
        label: 'Çağdaş Türk ve Dünya Tarihi',
        shortLabel: 'Çağdaş Tarih',
        dateRange: '1918 – Günümüz',
        subTopics: [
            'Birinci Dünya Savaşı\'nın Siyasi ve Ekonomik Sonuçları',
            'Çarlık Rusya\'nın Yıkılması ve SSCB\'nin Kurulması',
            'SSCB\'nin Kurulmasının Orta Asya Türk Toplumları Üzerindeki Etkisi',
            'Orta Doğu\'da Manda Yönetimlerinin Kurulması',
            'Hâkimiyet Teorileri, Uzak Doğu\'da Yeni Bir Güç Japonya ve 1929 Dünya Ekonomik Bunalımı',
            'İki Dünya Savaşı Arasındaki Dönem\'de Dünyada Barışın Sürekliliğini Sağlama Çabaları',
            'İki Dünya Savaşı Arasındaki Dönem\'de Sosyokültürel Olaylar ve Bilimsel Gelişmeler',
            'II. Dünya Savaşı Öncesinde Yaşanan Gelişmeler',
            'II. Dünya Savaşı\'nın Nedenleri ve Savaşın Başlaması',
            'Savaş Yılları',
            'II. Dünya Savaşı\'nın Seyrini Değiştiren Olaylar',
            'Barışa Doğru',
            'II. Dünya Savaşı\'nın Sona Ermesi ve Savaşın Etkileri',
            'II. Dünya Savaşı\'nda Türkiye',
            'Soğuk Savaş Dönemi (1947-1991)',
            'İki Kutuplu Dünya-Doğu Bloku',
            'İki Kutuplu Dünya-Batı Bloku',
            'Paylaşılamayan Orta Doğu',
            'Kore Savaşı (1950-1953)',
            'Asya ve Afrika\'daki Bağımsızlık Mücadeleleri',
            'Soğuk Savaş Dönemi\'nde Türkiye\'nin Dış Siyaseti',
            'Soğuk Savaş Dönemi\'nde Türkiye\'nin İç Siyaseti',
            'Soğuk Savaş Dönemi\'nde Türkiye ve Dünyada Yaşanan Sosyokültürel Gelişmeler',
            'Yumuşama (Detant) Dönemi (1961-1990)',
            'Vietnam Savaşı, Keşmir Meselesi, Afganistan\'ın İşgali ve Bağlantısızlar Hareketi',
            'Arap-İsrail Savaşları',
            'İslam İş Birliği Teşkilatı, Uluslararası Politikada Petrolün Yeri, İran-Irak Savaşı',
            'Yumuşama Dönemi\'nde Türk Dış Politikası-Kıbrıs Meselesi',
            'Yumuşama Dönemi\'nde Türk Dış Politikasının Diğer Meseleleri',
            'Türkiye\'de Bunalımlı Yıllar (1960-1983)',
            'Yumuşama Dönemi\'nde Dünyada ve Türkiye\'de Yaşanan Sosyokültürel Gelişmeler',
            'Küreselleşen Dünya-SSCB\'nin Dağılması',
            'SSCB\'nin Dağılmasının Etkileri – I',
            'SSCB\'nin Dağılmasının Etkileri – II',
            'Yenileşme Sürecinde Balkanlar',
            'Orta Doğu ve Afganistan\'da Yaşanan Gelişmeler',
            'Küreselleşen Dünyada Yaşanan Bazı Gelişmeler',
            'Küreselleşen Dünyada Türkiye',
            'Türkiye\'de Yaşanan Sosyal, Kültürel ve Bilimsel Gelişmeler',
        ],
    },
];
